import type { ReactNode } from 'react';

type RCtaVariant = 'primary' | 'outline' | 'ghost';

type Props = {
  children: ReactNode;
  beforeClick?: () => boolean;
  onClick?: () => void;
  disabled?: boolean;
  dimmed?: boolean;
  loading?: boolean;
  variant?: RCtaVariant;
  mini?: boolean;
};

const KIND: Record<RCtaVariant, string> = {
  primary: 'dsb-primary',
  outline: 'dsb-secondary',
  ghost: 'dsb-tertiary',
};

const RCta = ({
  children,
  beforeClick,
  onClick,
  disabled,
  dimmed,
  loading,
  variant = 'primary',
  mini,
}: Props) => (
  <button
    type="button"
    className={[
      'dsb',
      KIND[variant],
      mini ? 'dsb-m' : 'dsb-l',
      'dsb-block',
      dimmed && !loading ? 'is-dimmed' : '',
    ]
      .filter(Boolean)
      .join(' ')}
    disabled={disabled || loading}
    aria-busy={loading}
    onClick={() => {
      if (beforeClick?.() === false) return;
      onClick?.();
    }}
  >
    {loading ? (
      <span className="rg-btn-dots">
        <i />
        <i />
        <i />
      </span>
    ) : (
      children
    )}
  </button>
);

export { RCta };
